import {CompetitorFormHelper, FieldConfig} from "@model";
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'visibleCustomFields',
    standalone: false
})
export class VisibleCustomFieldsPipe implements PipeTransform {
    transform(formHelper: CompetitorFormHelper): FieldConfig[] {
        return formHelper.visibleCustomFields;
    }
}


